const AMAP_KEY = "56d6b0c77092db780857b2491c69d612";
const BASE_URL = "https://restapi.amap.com/v3";

/**
 * 地理编码：地址 → 经纬度
 */
export async function geocode(address, city = "") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    address,
    output: "JSON",
  });
  if (city) params.append("city", city);

  const res = await fetch(`${BASE_URL}/geocoding/geo?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.geocodes?.length > 0) {
    return data.geocodes;
  }
  return null;
}

/**
 * 逆地理编码：经纬度 → 地址
 */
export async function regeocode(location, extensions = "base") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    location,
    output: "JSON",
    extensions,
  });

  const res = await fetch(`${BASE_URL}/geocoding/regeo?${params}`);
  const data = await res.json();
  if (data.status === "1") {
    return data.regeocode;
  }
  return null;
}

/**
 * 关键词搜索 POI
 */
export async function searchPOI(keywords, city = "", types = "", page = 1, offset = 10) {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    keywords,
    output: "JSON",
    page: String(page),
    offset: String(offset),
    extensions: "all",
  });
  if (city) params.append("city", city);
  if (types) params.append("types", types);

  const res = await fetch(`${BASE_URL}/place/text?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.pois?.length > 0) {
    return data.pois;
  }
  return null;
}

/**
 * 周边搜索 POI
 */
export async function searchNearby(location, keywords = "", radius = 1000, types = "") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    location,
    radius: String(radius),
    output: "JSON",
    extensions: "all",
  });
  if (keywords) params.append("keywords", keywords);
  if (types) params.append("types", types);

  const res = await fetch(`${BASE_URL}/place/around?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.pois?.length > 0) {
    return data.pois;
  }
  return null;
}

/**
 * 天气查询
 */
export async function getWeather(city, extensions = "base") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    city,
    extensions,
    output: "JSON",
  });

  const res = await fetch(`${BASE_URL}/weather/weatherInfo?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.lives?.length > 0) {
    return data.lives[0];
  }
  if (data.status === "1" && data.forecasts?.length > 0) {
    return data.forecasts[0];
  }
  return null;
}

/**
 * IP 定位
 */
export async function ipLocation(ip = "") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    output: "JSON",
  });
  if (ip) params.append("ip", ip);

  const res = await fetch(`${BASE_URL}/ip?${params}`);
  const data = await res.json();
  if (data.status === "1") {
    return data;
  }
  return null;
}

/**
 * 路线规划 - 驾车
 */
export async function drivingRoute(origin, destination, strategy = 0, extensions = "all") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    origin,
    destination,
    strategy: String(strategy),
    extensions,
    output: "JSON",
  });

  const res = await fetch(`${BASE_URL}/direction/driving?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.route) {
    return data.route;
  }
  return null;
}

/**
 * 路线规划 - 步行
 */
export async function walkingRoute(origin, destination) {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    origin,
    destination,
    output: "JSON",
  });

  const res = await fetch(`${BASE_URL}/direction/walking?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.route) {
    return data.route;
  }
  return null;
}

/**
 * 获取静态地图图片 URL
 * 用于在消息里嵌入地图预览
 */
export function getStaticMapUrl(location, zoom = 15, size = "400*300", markers = "") {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    location,
    zoom: String(zoom),
    size,
  });
  if (markers) {
    params.append("markers", markers);
  } else {
    params.append("markers", `mid,,A:${location}`);
  }
  return `${BASE_URL}/staticmap?${params}`;
}

/**
 * 行政区域查询
 */
export async function districtSearch(keywords, subdistrict = 1) {
  const params = new URLSearchParams({
    key: AMAP_KEY,
    keywords,
    subdistrict: String(subdistrict),
    output: "JSON",
  });

  const res = await fetch(`${BASE_URL}/config/district?${params}`);
  const data = await res.json();
  if (data.status === "1" && data.districts?.length > 0) {
    return data.districts;
  }
  return null;
}
